import { MapPin } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import type React from "react";
import { View, XStack } from "tamagui";
import { Label } from "../../../ui/Label";
import type LocationModel from "../LocationModel";
import type { MapHandler } from "./Map";

export const MovePin: React.FC<{
  map: MapHandler;
  locationItem: LocationModel;
}> = observer(({ map, locationItem }) => {
  const handleChangeMarkerLocation = () => {
    map.setSelectionMode(true);
  };

  const handleSaveMarkerLocation = () => {
    const position = map?.mapSelectionMarker?.position;

    if (position) {
      locationItem.setMapData({
        lng: typeof position.lng === "number" ? position.lng : position.lng(),
        lat: typeof position.lat === "number" ? position.lat : position.lat(),
      });
    }

    map.setSelectionMode(false);
  };

  return (
    <View position="absolute" top={5} left={5} zIndex={10}>
      {map.selectionMode ? (
        <View
          disabled={!map.mapSelectionMarker}
          onPress={handleSaveMarkerLocation}
          cursor="pointer"
          backgroundColor={
            map.mapSelectionMarker ? "$primary" : "$backgroundBlock"
          }
          paddingVertical={5}
          paddingHorizontal={10}
        >
          <Label>
            {map.mapSelectionMarker
              ? "Save location"
              : "Select new location in map"}
          </Label>
        </View>
      ) : (
        <View
          backgroundColor={"$primary"}
          paddingVertical={12}
          paddingHorizontal={18}
          cursor="pointer"
          onPress={handleChangeMarkerLocation}
        >
          <XStack gap="$small" alignItems="center">
            <MapPin size={16} />
            <Label fontSize={12}>
              {locationItem.data.mapData ? "Move pin" : "Add pin"}
            </Label>
          </XStack>
        </View>
      )}
    </View>
  );
});
